import React, {
  useState, useEffect, useMemo,
} from 'react'
import QRCode from 'qrcode'
import {
  Page, Text, View, Document, StyleSheet, Image, PDFDownloadLink,
} from '@react-pdf/renderer'
import PrimaryButton, { StyledButton } from 'components/common/PrimaryButton'
import policies from 'assets/img/policies-for-pdf.png'
import { useSession } from 'components/auth/Session'

// TODO: this doesn't work for some reason:
// Font.register({ family: 'Poppins', src: 'https://fonts.gstatic.com/s/poppins/v12/pxiEyp8kv8JHgFVrJJnecnFHGPezSQ.woff2' });

// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#FFF',
    textAlign: 'center',
  },
  spaceName: {
    fontSize: 48,
  },
  instructions: {
    fontSize: 12,
  },
  qrCodeSection: {
    alignItems: 'center',
  },
  qrCode: {
    height: 300,
    width: 300,
  },
  policyImage: {
    width: '100%',
  },
  policyWrapper: {
    position: 'absolute',
    bottom: 0,
  },
})

let qrCodeBaseUrl:string
switch (process.env.NODE_ENV) {
  case 'production':
    qrCodeBaseUrl = 'https://app.birdlevel.com'
    break
  default:
    qrCodeBaseUrl = 'http://localhost:19006'
}

export function generateQRCode({ id, tenant, width = 300 }:{id:string, tenant: string, width?:number}) {
  // TODO: better url generation here
  return QRCode.toDataURL(`${qrCodeBaseUrl}/checkin/${id}?tenant=${tenant}`, { type: 'image/png', width })
}

function dataURItoBlob(dataURI: string) {
  // convert base64 to raw binary data held in a string
  // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
  const byteString = atob(dataURI.split(',')[1])

  // write the bytes of the string to an ArrayBuffer
  const ab = new ArrayBuffer(byteString.length)

  // create a view into the buffer
  const ia = new Uint8Array(ab)

  // set the bytes of the buffer to the correct values
  for (let i = 0; i < byteString.length; i += 1) {
    ia[i] = byteString.charCodeAt(i)
  }

  return Buffer.from(ab)
}

// Create Document Component
const Poster: React.FC<{ code: Buffer, name:string }> = ({ code, name }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <View style={styles.qrCodeSection}>
        <Image src={{ data: code, format: 'png' }} style={styles.qrCode} />
      </View>
      <View style={{ marginTop: 150 }}>
        <Text style={styles.spaceName}>{name}</Text>
        <Text style={styles.instructions}>Scan the QR code with your camera app to check-in</Text>
      </View>
      <View style={styles.policyWrapper}>
        <Image src={policies} style={styles.policyImage} />
      </View>
    </Page>
  </Document>
)

const DownloadButton:React.FC<{loading: boolean}> = ({ loading }) => {
  if (loading) {
    return <StyledButton disabled>Loading poster...</StyledButton>
  }

  return <PrimaryButton icon="file-download" title="Download Poster" />
}

export const SpacePDFLink: React.FC<{id: string, name: string}> = ({ id, name }) => {
  const { user } = useSession()
  const [data, setData] = useState<Buffer | undefined>(undefined)

  const poster = useMemo(() => {
    if (!data) {
      return undefined
    }
    return <Poster code={data} name={name} />
  }, [data, name])

  const tenant = user?.tenant?.slug || ''
  useEffect(() => {
    generateQRCode({ id, tenant }).then((resp) => {
      setData(dataURItoBlob(resp))
    }).catch((err) => {
      console.error('error generating qr code: ', err)
    })
  }, [id, tenant])

  if (data === undefined) {
    return <DownloadButton loading />
  }

  return (
    <PDFDownloadLink document={poster!} fileName={`poster-${name}.pdf`}>
      {({ loading }) => (<DownloadButton loading={loading} />)}
    </PDFDownloadLink>
  )
}
